/**
 * SaleSourceBadge — klon SourceBadge dla faktur sprzedaży.
 *
 * Pokazuje skąd przyszła faktura sprzedaży: manual / symfonia / ksef.
 * Używany w listing SaleInvoices + detail SaleInvoiceDetail.
 */

import { useTranslation } from 'react-i18next';
import { ArrowLeftRight, FileText, Pencil } from 'lucide-react';

import { Badge } from '@/components/Badge';

interface Props {
  source: string | null;
}

export function SaleSourceBadge({ source }: Props) {
  const { t } = useTranslation();
  const normalizedSource = source ?? 'manual';

  if (normalizedSource === 'symfonia') {
    return (
      <Badge color="accent">
        <ArrowLeftRight className="mr-1 inline h-3 w-3" aria-hidden="true" />
        {t('tenant.saleInvoices.source.symfonia')}
      </Badge>
    );
  }

  if (normalizedSource === 'ksef') {
    return (
      <Badge color="blue">
        <FileText className="mr-1 inline h-3 w-3" aria-hidden="true" />
        {t('tenant.saleInvoices.source.ksef')}
      </Badge>
    );
  }

  // manual (default) lub nieznane źródło
  return (
    <Badge color="gray">
      <Pencil className="mr-1 inline h-3 w-3" aria-hidden="true" />
      {t('tenant.saleInvoices.source.manual')}
    </Badge>
  );
}
